import { render, staticRenderFns } from "./BookNavigation.vue?vue&type=template&id=5d7deb9c&scoped=true"
import script from "./BookNavigation.vue?vue&type=script&lang=ts"
export * from "./BookNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BookNavigation.vue?vue&type=style&index=0&id=5d7deb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7deb9c",
  null
  
)

export default component.exports